// InlineError — the field/form-adjacent failure line, pure.
//
// The calm one-liner a form or dialog shows next to the control whose
// submission was refused (error-handling.md §5: a field error is INLINE,
// never a toast). Presentational only: the caller passes the already-
// localized message as children; this primitive contributes no strings.
//
// Colour is never the sole channel (SC 1.4.1): the line is danger-toned
// AND carries the warning-triangle glyph AND live-announces via
// role="alert" — the same contract Field's own error slot keeps. Use
// Field's `error` prop for a single control; use InlineError where the
// refusal belongs to the whole form/dialog rather than one field.

import type { ReactNode } from "react";
import { Icon } from "../Icon/Icon.js";
import { Text } from "../Text/Text.js";
import "./InlineError.css";

export type InlineErrorProps = {
    readonly children: ReactNode;
};

// Warning triangle — the redundant (non-colour) channel. Decorative to
// AT; the message carries the accessible meaning.
const errorGlyph = <Icon name="warning" />;

export const InlineError = ({ children }: InlineErrorProps): ReactNode => (
    <p className="bilda-inline-error" role="alert">
        <Text tone="danger">
            <span className="bilda-inline-error__glyph" aria-hidden="true">
                {errorGlyph}
            </span>
            {children}
        </Text>
    </p>
);
